import axios from 'axios';
import { API_BASE } from '../v1Api';

const API_BASE_AUDIT = API_BASE + '/audit';

export async function getAuditList(){
  return await axios({
    baseURL: API_BASE_AUDIT,
    url: `/all/fetch`,
    method: 'GET'
  })
    .then((resp) => {
        console.log(resp);
      return resp.data;
    })
    .catch((err) => {
      throw new Error('No data!');
    });
}

export async function searchAuditList(data){
    return await axios({
      baseURL: API_BASE_AUDIT,
      url: `/search`,
      method: 'POST',
      data: data
    })
      .then((resp) => {
          console.log(resp);
        return resp.data;
      })
      .catch((err) => {
        throw new Error('No data!');
      });
  }
